import { render, staticRenderFns } from "./project_qtys.vue?vue&type=template&id=a36d4616&scoped=true&"
import script from "./project_qtys.vue?vue&type=script&lang=js&"
export * from "./project_qtys.vue?vue&type=script&lang=js&"
import style0 from "./project_qtys.vue?vue&type=style&index=0&id=a36d4616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36d4616",
  null
  
)

export default component.exports